export default __webpack_public_path__ + "img/app-page/screen2_us.ebfd28fdd6835940c0c35d5826020ffd.png";